import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function EmbedIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m14.455 4.96343-3.6 14.39997-1.31013-.3269 3.60003-14.40003z" />
        <path d="m7.65933 8.59448-3.66797 3.40552 3.66797 3.4054-.91875.9891-4.2-3.9c-.13749-.1277-.21563-.3069-.21563-.4945 0-.1877.07814-.3669.21563-.4946l4.2-3.89998z" />
        <path d="m16.3406 8.59448 3.6679 3.40552-3.6679 3.4054.9187.9891 4.2-3.9c.1375-.1277.2157-.3069.2157-.4945 0-.1877-.0782-.3669-.2157-.4946l-4.2-3.89998z" />
      </g>
    </SVGWrapper>

  );
}

export default EmbedIcon;
